// src/components/TagPills.tsx
"use client";

import { Link } from "@/i18n/navigation"; // ← your next-intl navigation wrapper
import type { Tag } from "@/types/timeline";

type Props = {
  tags: Tag[];
  size?: "small" | "medium";
  /** Path without locale prefix. next-intl Link adds the locale. */
  hrefPrefix?: string;
};

export default function TagPills({
  tags,
  size = "medium",
  hrefPrefix = "/timeline",
}: Props) {
  if (!tags.length) return null;

  const sizeStyle: React.CSSProperties =
    size === "small"
      ? { fontSize: "0.7rem", padding: "0.15rem 0.5rem" }
      : { fontSize: "0.78rem", padding: "0.22rem 0.6rem" };

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "0.35rem",
        alignItems: "center",
      }}
    >
      {tags.map((tag) => (
        <Link
          key={tag.id}
          href={`${hrefPrefix}?tag=${encodeURIComponent(tag.slug)}`}
          title={tag.post_count ? `${tag.post_count} posts` : undefined}
          style={{
            ...sizeStyle,
            borderRadius: "999px",
            border:
              "1px solid color-mix(in srgb, currentColor 14%, transparent)",
            background: "color-mix(in srgb, currentColor 5%, transparent)",
            color: "inherit",
            textDecoration: "none",
            whiteSpace: "nowrap",
            fontWeight: 500,
            opacity: 0.85,
          }}
        >
          #{tag.title}
        </Link>
      ))}
    </div>
  );
}
